__webpack_require__.p = "https://verisart-shopify-proxy-prod.herokuapp.com//";